import { DASHBOARD } from './config'
import dashboard from '../dashboard/dashboard.json'
const cache = {}

const getItem = (key) => (cache[key])

const setItem = (key, value) => {
    cache[key] = value
}

const removeItem = (key) => { delete cache[key] }

const getDashboard = () => (getItem(DASHBOARD))

const setDashboard = (dash) => {
    setItem(DASHBOARD, dash || dashboard)
}

export default {
    getItem, setItem, removeItem,
    getDashboard, setDashboard
}